/**
 * repurpose/Channels.jsx
 * Where the copy is going, and which of those Kreeboom can actually carry.
 *
 * The badge is the honest part of this screen. Kreeboom publishes to Facebook
 * and Instagram; everything else is writing, and a person who does not know
 * that before they press the button will find out at the worst moment. So the
 * split is shown here, before generating, with the reason attached — and the
 * reason comes from the server, which is the thing that will decide.
 *
 * Dependencies: components/Icons.jsx
 */

import { Check, Clipboard } from '../Icons.jsx';

export default function Channels({ channels, chosen, onToggle, max }) {
  const carried = channels.filter((c) => c.draftable);
  const copyOnly = channels.filter((c) => !c.draftable);

  const full = chosen.length >= max;

  const tile = (c) => {
    const on = chosen.includes(c.key);
    return (
      <li key={c.key}>
        <button
          type="button"
          className={`rp-channel ${on ? 'is-on' : ''}`}
          onClick={() => onToggle(c.key)}
          disabled={!on && full}
          aria-pressed={on}
        >
          <span className="rp-channel__tick">{on && <Check size={13} />}</span>
          <span className="rp-channel__body">
            <span className="rp-channel__name">{c.label}</span>
            <span className="rp-channel__note">
              {c.parts
                ? `${c.parts} parts`
                : c.slides
                  ? `${c.slides} slides`
                  : `up to ${c.maxChars.toLocaleString()} characters`}
            </span>
          </span>
        </button>
      </li>
    );
  };

  return (
    <section className="rp-channels card">
      <header className="rp-channels__head">
        <h2>Write it for</h2>
        <span className="muted">
          {chosen.length} of {max} chosen
        </span>
      </header>

      <div className="rp-group">
        <h3>
          <Check size={14} /> Kreeboom can post these
        </h3>
        <p className="muted">
          Saved as an ordinary draft, and approved in Drafts like anything else. Nothing here
          schedules or publishes.
        </p>
        <ul className="rp-channel-list">{carried.map(tile)}</ul>
      </div>

      <div className="rp-group">
        <h3>
          <Clipboard size={14} /> Written for you to copy across
        </h3>
        <p className="muted">
          Kreeboom holds no accounts for these, so it writes them and you paste them.
        </p>
        <ul className="rp-channel-list">{copyOnly.map(tile)}</ul>
        <ul className="rp-why">
          {copyOnly.map((c) => (
            <li key={c.key}>
              <strong>{c.label}</strong> — {c.reason}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
